export default {
  '订购主体：': 'Order subject:',
  没有更多了: 'No more available',
  '套餐编号：': 'Package number:',
  '已使用：{used}份 剩余：{margin}份': 'Already used: {used}, remaining: {margin} copies',
  '截止日期:': 'Deadline:',
  '您还没订购过套餐~': 'You have not ordered a package yet~',
  订购: 'Order',
  再次订购: 'Order again',
  返回: 'Back',
  已购套餐: 'Purchased package',
  '加载中...': 'Loading...',
  已失效: 'Expired',
  待生效: 'To be effective',
  生效中: 'In effect',
  已停用: 'Disabled',
  已终止: 'Terminated',
  冻结中: 'Frozen',
  交易成功: 'Transaction successful',
  电子签名服务: 'Electronic signature service',
  '订购主体:': 'Order subject:',
  元: 'Yuan',
  '暂不支持苹果手机支付，请用其他平台支付或联系服务商':
    'Apple mobile payment is not supported yet, please use other platforms or contact the service provider.',
  联系服务商: 'Contact service provider',
  立即结算: 'Settle now',
  购买: 'Purchase',
  以下合同均自购买日起一年内有效: 'The following contracts are valid for one year from the date of purchase',
  '当前企业的版本为{slot}，仅支持签署合同/文件。若要发起合同，请订阅购买会员版本。':
    'The current company version is {slot}. Only signing contracts/documents is supported. If you want to initiate a contract, please subscribe and purchase the member version.',
  提交订单: 'Submit order',
}
